import { httpClient } from "../../../shared/api";

export const rbacApi = {
  myPermissions() {
    return httpClient.get("/rbac/my-permissions");
  },

  listModules() {
    return httpClient.get("/rbac/modules");
  },

  listRoles() {
    return httpClient.get("/rbac/roles");
  },

  listAllPermissions() {
    return httpClient.get("/rbac/permissions");
  },

  getRolePermissions(role) {
    return httpClient.get(`/rbac/permissions/${encodeURIComponent(role)}`);
  },

  setRolePermissions(role, grants) {
    return httpClient.put(`/rbac/permissions/${encodeURIComponent(role)}`, { grants });
  },
};
